import Link from 'next/link';
import AppIcon from '@/components/ui/AppIcon';

interface QuickNavBlockProps {
  className?: string;
}

const navItems = [
  {
    label: 'Dive Sites in Cyprus',
    href: '/dive-sites',
    icon: 'MapIcon' as const,
    description: 'Find the best wrecks, reefs, caves, and shore dives — with real conditions, entry points, and what to expect underwater.',
  },
  {
    label: 'Marine Life Guide',
    href: '/marine-life',
    icon: 'GlobeAltIcon' as const,
    description: 'See what you\'re likely to encounter — from groupers and turtles to octopus and seasonal visitors.',
  },
  {
    label: 'Dive Centres',
    href: '/dive-centres-directory',
    icon: 'BuildingOfficeIcon' as const,
    description: 'Browse dive centres across Cyprus — with clear, practical information to help you choose where to dive.',
  },
  {
    label: 'Plan Your Dive Trip',
    href: '/cyprus-diving-information',
    icon: 'CalendarIcon' as const,
    description: 'Understand seasons, visibility, water temperatures, and when to dive each region.',
  },
];

const QuickNavBlock = ({ className = '' }: QuickNavBlockProps) => {
  return (
    <section
      className={`py-8 sm:py-10 ${className}`}
      style={{
        background: '#0B1622',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {navItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className="group flex flex-col items-center text-center gap-2 px-3 py-4 sm:py-5 rounded-xl transition-all duration-250"
              style={{
                background: '#0F2234',
                border: '1px solid rgba(255,255,255,0.08)',
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.border = '1px solid rgba(111,211,224,0.35)';
                el.style.transform = 'translateY(-2px)';
                el.style.boxShadow = '0 6px 20px rgba(0,0,0,0.35)';
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.border = '1px solid rgba(255,255,255,0.08)';
                el.style.transform = 'translateY(0)';
                el.style.boxShadow = 'none';
              }}
            >
              <div
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center flex-shrink-0"
                style={{
                  background: 'rgba(255,138,61,0.12)',
                  border: '1.5px solid rgba(255,138,61,0.30)',
                }}
              >
                <AppIcon name={item.icon} size={22} style={{ color: '#FF8A3D' }} />
              </div>
              <div>
                <p className="font-semibold text-sm sm:text-base leading-tight mb-0.5" style={{ color: '#EAF4F8' }}>
                  {item.label}
                </p>
                <p className="text-xs" style={{ color: '#A9C3CF' }}>
                  {item.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickNavBlock;
